// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';

const DOMAIN = window.location.origin;

export default function TenantList({ tenants, loading, onEdit, onCreateNew, onRefresh }) {
  return (
    <div className="tenant-list">
      <div className="tenant-list__toolbar">
        <h2 className="tenant-list__title">Tenants ({tenants.length})</h2>
        <div className="tenant-list__actions">
          <button className="admin-btn admin-btn--secondary" onClick={onRefresh} disabled={loading}>
            ↻ Refresh
          </button>
          <button className="admin-btn admin-btn--primary" onClick={onCreateNew}>
            + New Tenant
          </button>
        </div>
      </div>

      {loading && tenants.length === 0 ? (
        <div className="tenant-list__loading">Loading tenants…</div>
      ) : tenants.length === 0 ? (
        <div className="tenant-list__empty">
          <p>No tenants yet. Click "New Tenant" to create one.</p>
        </div>
      ) : (
        <div className="tenant-list__grid">
          {tenants.map((t) => (
            <div key={t.tenantId} className={`tenant-card${t.status === 'inactive' ? ' tenant-card--inactive' : ''}`}>
              <div className="tenant-card__header">
                <h3 className="tenant-card__name">{t.name}</h3>
                <span className={`tenant-card__status tenant-card__status--${t.status}`}>
                  {t.status}
                </span>
              </div>
              <div className="tenant-card__meta">
                <span className="tenant-card__slug">/{t.slug}</span>
                <span className="tenant-card__cats">{t.categories?.length || 0} categories</span>
                <span className="tenant-card__scheme">{t.branding?.colorScheme || 'default'}</span>
              </div>
              {(t.accessCodes?.length > 0 || t.accessCode) && (
                <div className="tenant-card__access-code">
                  {t.accessCodes?.length > 0
                    ? `${t.accessCodes.length} access code${t.accessCodes.length > 1 ? 's' : ''}: ${t.accessCodes.map((ac) => ac.code).join(', ')}`
                    : `Access Code: ${t.accessCode}`
                  }
                </div>
              )}
              <div className="tenant-card__url">
                <a href={`${DOMAIN}/t/${t.slug}`} target="_blank" rel="noopener noreferrer">
                  {DOMAIN}/t/{t.slug}
                </a>
              </div>
              <div className="tenant-card__actions">
                <button className="admin-btn admin-btn--small" onClick={() => onEdit(t)}>
                  Edit
                </button>
                <a
                  href={`${DOMAIN}/t/${t.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="admin-btn admin-btn--small admin-btn--secondary"
                >
                  Open ↗
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
